import { ClaimCreateUseCase } from '../../../application';

export default class ClaimCreateService {
    constructor() {}

    async execute(event) {
        const request = await ClaimCreateUseCase(event);

        return request;
    }
}
